import { render, staticRenderFns } from "./FullVideo.vue?vue&type=template&id=1a38c5c9&scoped=true&lang=pug&"
import script from "./FullVideo.vue?vue&type=script&lang=js&"
export * from "./FullVideo.vue?vue&type=script&lang=js&"
import style0 from "./FullVideo.vue?vue&type=style&index=0&id=1a38c5c9&lang=sass&nolang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a38c5c9",
  null
  
)

export default component.exports